// 引入数据配置文件
import FormConfig from "../formConfig.js";
import { fun_PostAction, fun_GetAction } from "@/api/index";
// 引入转译方法
import CaLock from "@/components/common/calock";
import SupConstructionChoose from "../../components/supConstructionChooseDialog/index.vue";
import AuditHistoryRecord from "../../../components/auditHistoryRecord/index.vue";
import { Loading } from "element-ui";
export default {
  data() {
    return {
      // 判断是否从工作台进入
      workbenchMenu: null,
      // 工作台状态
      workbenchState: false,
      // 流程状态
      stepsActive: 0,
      // 流程数据
      stepsList: [
        {
          name: "项目信息导入",
          isSave: false, // 是否保存
          isActive: true, // 是否可点击
          formList: FormConfig.projectInformation()
        },
        {
          name: "建设信息",
          isSave: false,
          isActive: true,
          formList: FormConfig.biddingInformation()
        },
        {
          name: "项目基本信息",
          isSave: false,
          isActive: true,
          formList: FormConfig.basicProjectInformation()
        },
        {
          name: "工程概况",
          isSave: false,
          isActive: true,
          formList: FormConfig.projectOverview()
        },
        {
          name: "其他信息",
          isSave: false,
          isActive: true,
          formList: FormConfig.otherInformation()
        }
      ],
      // 表单配置
      formConfigList: FormConfig.projectInformation(),
      // 表单绑定值
      form: {
        id: null, // 主键
        state: null, // 状态
        applicationId: null,
        dataType: null,
        constructionFlagProject: null,
        loginNo: null, // 登录号
        loginPwd: null, // 密码
        relateCode: null, // 项目类别关联代码
        investProjectCode: null, // 投资项目统一代码
        tenderCorpChangeType: null, // 招标人变更类型
        buildCorpName: null, // 现建设单位名称
        buildCorpCode: null, // 现建设单位组织机构代码
        buildCorpAddress: null, // 现建设单位地址
        buildCorpLegal: null, // 现建设单位法定代表人
        buildCorpProperty: null, // 现建设单位单位性质
        buildCorpLinkMan: null, // 现建设单位联系人
        buildCorpLinkTel: null, // 现建设单位联系人电话
        buildCorpLinkMobile: null, // 现建设单位联系人手机
        buildCorpPostalCode: null, // 现建设单位邮编
        buildCorpFax: null, // 现建设单位传真
        buildCorpEMail: null, // 现建设单位电子邮件
        constructionNo: null, // 报建编号
        prjName: null, // 工程名称
        prjAddress: null, // 工程地点
        prjLargeClass: null, // 工程类别
        prjCategory: null, // 工程小类
        noteNumber: null, // 立项文号
        approveLevel: null, // 立项级别
        approveType: null, // 立项形式
        approveUnit: null, // 批准单位
        totalInvestmentAmount: null, // 批准投资总额
        investmentPlanThisYear: null, // 本年度投资计划
        stateProfitInvestment: null, // 国有盈利性投资
        stateNonprofitInvestment: null, // 国有非盈利性投资
        nonstateInvestment: null, // 非国有投资
        foreignInvestment: null, // 外资
        industryClass: null, // 项目行业门类
        industryCode: null, // 项目行业分类
        industryClassProvince: null, // 项目行业分类（湖北省）
        regulators: null, // 行政监督部门
        projectScale: null, // 工程规模
        constructionType: null, // 报建性质
        constructionGrade: null, // 报建等级
        isKeyProject: null, // 重点工程
        layersFollowingThirtyTwo: null, // 规划建筑层数32层以下
        layersAboveThirtyTwo: null, // 规划建筑层数32层（含）以上
        depthFollowingNine: null, // 深基坑深度9米以下
        depthAboveNine: null, // 深基坑深度9米（含）以上
        heightFollowingOneHundred: null, // 建筑高度100米以下
        heightAboveOneHundred: null, // 建筑高度100米（含）以上
        spanFollowingThirtyTwo: null, // 公共建筑跨度30米以下
        spanAboveThirtyTwo: null, // 公共建筑跨度30米（含）以上
        isRealEstateProject: null, // 是否房地产开发
        isIndustryProject: null, // 是否工业项目
        description: null, // 备注
        opinion: null, // 报建单位意见
        handleOpinion: null, // 办理意见
        constructionFlag: null,
        inputPerson: null,
        inputMode: null,
        insertDate: null,
        updateDate: null,
        firstConstructionId: null, // 原建设方（甲方）报建主键
        firstConstructionNo: null, // 原建设方（甲方）报建编号
        firstConstructionPrjName: null, // 工程名称
        isAudit: null, // 是否需要核验
        digitalSignature: null, // 数字签名
        lockNo: null, // 锁编号
        projectType: null, // 项目类型
        transactionId: null, // 交易目录名称
        isConstructionProject: null, // 是否工程建设项目
        tenderMethod: null, // 招标组织形式
      },
      // 表单错误提示
      errRules: {
        id: null, // 主键
        state: null, // 状态
        applicationId: null,
        dataType: null,
        constructionFlagProject: null,
        loginNo: null, // 登录号
        loginPwd: null, // 密码
        relateCode: null, // 项目类别关联代码
        investProjectCode: null, // 投资项目统一代码
        tenderCorpChangeType: null, // 招标人变更类型
        buildCorpName: null, // 现建设单位名称
        buildCorpCode: null, // 现建设单位组织机构代码
        buildCorpAddress: null, // 现建设单位地址
        buildCorpLegal: null, // 现建设单位法定代表人
        buildCorpProperty: null, // 现建设单位单位性质
        buildCorpLinkMan: null, // 现建设单位联系人
        buildCorpLinkTel: null, // 现建设单位联系人电话
        buildCorpLinkMobile: null, // 现建设单位联系人手机
        buildCorpPostalCode: null, // 现建设单位邮编
        buildCorpFax: null, // 现建设单位传真
        buildCorpEMail: null, // 现建设单位电子邮件
        constructionNo: null, // 报建编号
        prjName: null, // 工程名称
        prjAddress: null, // 工程地点
        prjLargeClass: null, // 工程类别
        prjCategory: null, // 工程小类
        noteNumber: null, // 立项文号
        approveLevel: null, // 立项级别
        approveType: null, // 立项形式
        approveUnit: null, // 批准单位
        totalInvestmentAmount: null, // 批准投资总额
        investmentPlanThisYear: null, // 本年度投资计划
        stateProfitInvestment: null, // 国有盈利性投资
        stateNonprofitInvestment: null, // 国有非盈利性投资
        nonstateInvestment: null, // 非国有投资
        foreignInvestment: null, // 外资
        industryClass: null, // 项目行业门类
        industryCode: null, // 项目行业分类
        industryClassProvince: null, // 项目行业分类（湖北省）
        regulators: null, // 行政监督部门
        projectScale: null, // 工程规模
        constructionType: null, // 报建性质
        constructionGrade: null, // 报建等级
        isKeyProject: null, // 重点工程
        layersFollowingThirtyTwo: null, // 规划建筑层数32层以下
        layersAboveThirtyTwo: null, // 规划建筑层数32层（含）以上
        depthFollowingNine: null, // 深基坑深度9米以下
        depthAboveNine: null, // 深基坑深度9米（含）以上
        heightFollowingOneHundred: null, // 建筑高度100米以下
        heightAboveOneHundred: null, // 建筑高度100米（含）以上
        spanFollowingThirtyTwo: null, // 公共建筑跨度30米以下
        spanAboveThirtyTwo: null, // 公共建筑跨度30米（含）以上
        isRealEstateProject: null, // 是否房地产开发
        isIndustryProject: null, // 是否工业项目
        description: null, // 备注
        opinion: null, // 报建单位意见
        handleOpinion: null, // 办理意见
        constructionFlag: null,
        inputPerson: null,
        inputMode: null,
        insertDate: null,
        updateDate: null,
        firstConstructionId: null, // 原建设方（甲方）报建主键
        firstConstructionNo: null, // 原建设方（甲方）报建编号
        firstConstructionPrjName: null, // 工程名称
        isAudit: null, // 是否需要核验
        digitalSignature: null, // 数字签名
        lockNo: null, // 锁编号
        projectType: null, // 项目类型
        transactionId: null, // 交易目录名称
        isConstructionProject: null, // 是否工程建设项目
      },
      // 全局加载
      fullLoading: null,
      // 文件下载路径
      url: null,
      // 主键
      id: this.$route.query.id,
      // 操作类型
      controllerFlg: this.$route.query.controllerFlg, // 操作标志
      // 用于判断状态图片
      flagState: null
    };
  },

  // 注册组件
  components: {
    CaLock, // CA锁
    SupConstructionChoose,
    AuditHistoryRecord, // 历史核验记录
  },
  // 模板编译前
  created() {

  },
  // 模板编译完成
  mounted() {
    // 默认获取第一个流程表单
    this.formConfigList = this.stepsList[this.stepsActive].formList;
    // 不为新增的时候
    if (this.controllerFlg != "insert") {
      // 获取详情
      this.fun_GetDetail();
      // 重新加载节点
      this.fun_ReloadStepList();
      // 如果是详情
      if (this.controllerFlg === "detail") {
        // 遍历流程
        this.stepsList.map(e => {
          (e.isSave = true), // 默认保存
            (e.isActive = true); // 默认可点击
          // 遍历标签页
          e.formList.map(formList => {
            // 遍历标签页内表单
            formList.formConfigList.map(form => {
              // 置灰
              form.disabled = true;
            });
          });
        });
        this.formConfigList.map(form => {
          // 遍历标签页内表单
          form.formConfigList.map(e => {
            // 置灰
            e.disabled = true;
          });
        });
      }
    } else {
      // 初始化
      this.fun_InsertInit();
    }
  },
  // 自定义方法
  methods: {
    /**
     * 添加初始化
     */
    fun_InsertInit() {
      // 发起请求
      fun_PostAction("/supConstruction/insertInit" ).then(res => {
        // 结构res.data
        const { result, data, msg } = res.data;
        // 请求成功
        if (result) {
          // 建设单位名称
          this.form.buildCorpName = data.buildCorpName;
          // 组织机构代码
          this.form.buildCorpCode = data.buildCorpCode;
          // 地址
          this.form.buildCorpAddress = data.buildCorpAddress;
          // 法人
          this.form.buildCorpLegal = data.buildCorpLegal;
          // 联系人
          this.form.buildCorpLinkMan = data.buildCorpLinkMan;
          // 联系电话
          this.form.buildCorpLinkTel = data.buildCorpLinkTel;
          // 联系手机
          this.form.buildCorpLinkMobile = data.buildCorpLinkMobile;
          // 邮政编码
          this.form.buildCorpPostalCode = data.buildCorpPostalCode;
          // 传真
          this.form.buildCorpFax = data.buildCorpFax;
          // 电子邮箱
          this.form.buildCorpEMail = data.buildCorpEMail;
          // 建设单位单位性质
          this.form.buildCorpProperty = data.buildCorpProperty;
          // 设置类型--默认为0--报建旧数据
          this.form.dataType = data.dataType;
        } else {
          // 提示请求失败的信息
          this.$message.error(msg);
        }
      });
    },
    /**
     * 获取详情
     */
    fun_GetDetail() {
      // 发起请求
      fun_GetAction("/supConstruction/detail", {
        id: this.id
      }).then(res => {
        // 结构res.data
        const { result, data, msg } = res.data;
        // 请求成功
        if (result) {
          // 表格数据
          this.form = data;
          // 获取状态用于判断显示图片
          this.flagState = data.state;
          // 执行处理页面显示方法
          this.fun_GetHandle();
        } else {
          // 提示请求失败的信息
          this.$message.error(msg);
        }
      });
    },
    /**
     * 需要处理页面显示逻辑代码
     */
    fun_GetHandle() {
      // 如果项目关联代码为无
      if (this.form.relateCode == "0") {
        // 遍历查询表单
        this.formConfigList[0].formConfigList.map(e => {
          // 如果是投资项目统一代码
          if (e.value === "investProjectCode") {
            e.disabled = true; // 置灰
            e.rule.required = false; // 设置成非必填
          }
        });
      }
      // 工程类别不为空
      if(this.form.prjLargeClass){
        // 遍历查询表单
        this.stepsList[2].formList[0].formConfigList.map(e => {
          // 如果是工程小类
          if (e.value === "prjCategory") {
            // 修改下拉框请求参数，重新赋值
            e.queryParams = {
              url: "/dataDictionaryEntries/engineeringCombobox",
              parentId: this.form.prjLargeClass
            };
          }
        });
      }
      // 项目行业门类不为空
      if(this.form.industryClass){
        // 遍历查询表单
        this.stepsList[0].formList[2].formConfigList.map(e => {
          // 如果是项目行业分类
          if (e.value === "industryCode") {
            // 修改下拉框请求参数，重新赋值
            e.queryParams = {
              url: "/industryCode/IndustryCodeCombobox",
              industryId: this.form.industryClass,
              flag: 0
            };
          }
        });
      }
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i, arr) {
      // 赋值
      this.form[i] = e;
      // 项目类别关联代码
      if (i === "relateCode") {
        // 如果选的是无
        if (e == "0") {
          // 清空
          this.form.investProjectCode = null;
          // 遍历查询表单
          this.stepsList[0].formList[1].formConfigList.map(f => {
            // 如果是投资项目统一代码
            if (f.value === "investProjectCode") {
              f.disabled = true; // 置灰
              f.rule.required = false; // 设置成非必填
            }
          });
        } else {
          // 遍历查询表单
          this.stepsList[0].formList[1].formConfigList.map(f => {
            // 如果是投资项目统一代码
            if (f.value === "investProjectCode") {
              f.disabled = false; // 取消置灰
              f.rule.required = true; // 设置成必填
            }
          });
        }
      }
      // 工程类别
      else if (i === "prjLargeClass") {
        // 遍历查询表单
        this.stepsList[2].formList[0].formConfigList.map(f => {
          // 如果是工程小类
          if (f.value === "prjCategory") {
            // 修改下拉框请求参数，重新赋值
            f.queryParams = {
              url: "/dataDictionaryEntries/engineeringCombobox",
              parentId: this.form.prjLargeClass
            };
          }
        });
      }
      // 项目行业门类
      else if (i === "industryClass") {
        // 清空项目行业分类值
        this.form.industryCode = null;
        // 遍历表单
        this.stepsList[0].formList[2].formConfigList.map(f => {
          // 如果是项目行业分类
          if (f.value === "industryCode") {
            // 修改下拉框请求参数，重新赋值
            f.queryParams = {
              url: "/industryCode/IndustryCodeCombobox",
              industryId: this.form.industryClass,
              flag: 0
            };
          }
        });
      }
    },
    /**
     * 点击流程
     */
    fun_GetClickSteps(val, index) {
      // 判断是否可点击
      if (val.isActive) {
        // 是否填写当前表单
        if (this.fun_GetStepsIsData()) {
          // 设置当前流程已保存
          this.stepsList[this.stepsActive].isSave = true;
        }
        // 如果不是详情
        if (this.controllerFlg !== "detail") {
          // 判断是否填写项目名称
          if (!this.form.prjName) {
            // 提示
            this.$alert("请填写项目名称！", "warning");
            this.errRules.prjName = "请填写项目名称！";
            return false;
          }
          // 保存当前表单
          this.fun_NextSaveOrUpdate("bc");
        }
        // 赋值下标
        this.stepsActive = index;
        // 获取表单数据
        this.formConfigList = val.formList;
        // 判断项目行业分类是否有值
        if (this.form.industryCode) {
          // 遍历表单
          this.stepsList[0].formList[2].formConfigList.map(f => {
            // 如果是项目行业分类
            if (f.value === "industryCode") {
              // 修改下拉框请求参数，重新赋值
              f.queryParams = {
                url: "/industryCode/IndustryCodeCombobox",
                industryId: this.form.industryClass,
                flag: 0
              };
            }
          });
        } else {
          // 清空项目行业分类值
          this.form.industryCode = null;
        }
      }
    },
    /**
     * 上一步
     */
    fun_GetLastStep() {
      // 如果不是详情
      if (this.controllerFlg !== "detail") {
        // 判断是否填写项目名称
        if (!this.form.prjName) {
          // 提示
          this.$alert("请填写项目名称！", "warning");
          this.errRules.prjName = "请填写项目名称！";
          return false;
        }
        // 保存当前表单
        this.fun_NextSaveOrUpdate("bc");
      }
      // 是否填写当前表单
      if (this.fun_GetStepsIsData()) {
        // 设置当前流程已保存
        this.stepsList[this.stepsActive].isSave = true;
      }
      // 减1
      this.stepsActive--;
      // 获取表单数据
      this.formConfigList = this.stepsList[this.stepsActive].formList;
    },
    /**
     * 下一步
     */
    fun_GetNextStep() {
      // 如果不是详情
      if (this.controllerFlg !== "detail") {
        // 判断是否填写项目名称
        if (!this.form.prjName) {
          // 提示
          this.$alert("请填写项目名称！", "warning");
          this.errRules.prjName = "请填写项目名称！";
          return false;
        }
        // 保存当前表单
        this.fun_NextSaveOrUpdate("bc");
      }
      // 是否填写当前表单
      if (this.fun_GetStepsIsData()) {
        // 设置当前流程已保存
        this.stepsList[this.stepsActive].isSave = true;
      }
      // 加1
      this.stepsActive++;
      // 设置下一个流程可点击
      this.stepsList[this.stepsActive].isActive = true;
      // 获取表单数据
      this.formConfigList = this.stepsList[this.stepsActive].formList;
    },
    /**
     * 验证表单
     * @param {*} i tabs切换
     */
    fun_val(i, state) {
      // 验证第一个表单
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        if (valid) {
          // 最后一个表单
          if (i === this.stepsList.length - 1) {
            // 执行保存
            this.fun_SaveOrUpdate(state);
          } else {
            // 重置表单配置
            this.formConfigList = this.stepsList[i + 1].formList;
            this.$nextTick(() => {
              // 递归验证表单
              this.fun_val(i + 1, state);
            });
          }
        } else {
          // 定位到未填表单
          this.stepsActive = i;
          // 提示
          this.$alert("页面存在错误信息，请检查后重试！", "warning");
          return false;
        }
      });
    },
    /**
     * 确定的方法
     * @author shuhua
     */
    fun_Submit(state,flag) {
      // 状态赋值
      this.form.state = state;
      // 如果时保存
      if (state === "bc" && !flag) {
        // 判断是否填写项目名称
        if (!this.form.prjName) {
          // 提示
          this.$alert("请填写项目名称！", "warning");
          this.errRules.prjName = "请填写项目名称！";
          return false;
        }
        // 保存
        this.fun_NextSaveOrUpdate(state);
        return;
      }else if (state == "bc" && flag){
        // 执行保存
        this.fun_SaveOrUpdate(state);
        return;
      }
      // 自定义下标
      let i = 0;
      // 验证当前表单
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        // 验证通过
        if (valid) {
          // 重置表单配置
          this.formConfigList = this.stepsList[i].formList;
          this.$nextTick(() => {
            // 验证表单
            this.fun_val(i, state);
          });
        } else {
          // 提示
          this.$alert("页面存在错误信息，请检查后重试！", "warning");
          return false;
        }
      });
    },
    /**
     * 保存或修改的方法
     * @author shuhua
     */
    fun_SaveOrUpdate(state, lockNo, digitalSignature) {
      // 状态赋值
      this.form.state = state;
      // 遍历错误消息
      for (let i in this.errRules) {
        // 设置为空
        this.errRules[i] = null;
      }
      // 打开遮罩
      this.fun_Loading();
      // 发起请求
      fun_PostAction("supConstruction/saveOrUpdate", {
        ...this.form,
        controllerFlg: this.controllerFlg
      }).then(res => {
        // 解构res.data
        const { result, msg, data } = res.data;
        // 操作成功
        if (result) {
          // 如果保存成功
          if(data.result){
            // 回传id
            this.id = data.data.id;
            // 操作成功
            this.$message.success(data.msg);
            // 加载框取消
            this.fullLoading.close();
            // 如果是保存
            if(this.form.state == "bc"){
              // 修改状态
              this.controllerFlg = "update";
              // 加载详情
              this.fun_GetDetail();
            }else{
              // 返回一览
              this.fun_Back();
            }
          }else{
            // 提示请求失败消息
            this.$message.error(data.msg);
          }
        } else {
          // 加载框取消
          this.fullLoading.close();
          // 返回不为空
          if (data != null) {
            // 定义rules为一个随机数
            this.errRules = Math.random();
            // 执行延迟方法
            this.$nextTick(() => {
              // 提示
              this.$message.error("您输入的数据存在错误！");
              // 赋值错误消息
              this.errRules = data;
            });
          } else {
            // 提示请求失败消息
            this.$message.error(msg);
          }
        }
      });
    },
    /**
     * 下一步保存或修改的方法
     * @author shuhua
     */
    fun_NextSaveOrUpdate(state) {
      // 状态赋值
      this.form.state = state;
      // 打开遮罩
      this.fun_Loading();
      // 发起请求
      fun_PostAction("supConstruction/saveOrUpdate", {
        ...this.form,
        controllerFlg: this.controllerFlg
      })
        .then(res => {
          // 解构res.data
          const { result, data } = res.data;
          // 操作成功
          if (result) {
            // 如果保存成功
            if(data.result){
              // 回传id
              this.id = data.data.id;
              // 修改状态
              this.controllerFlg = "update";
              // 加载详情
              this.fun_GetDetail();
              // 加载框取消
              this.fullLoading.close();
            }else{
              // 加载框取消
              this.fullLoading.close();
            }
          }
        })
        .catch(error => {
          // 加载框取消
          this.fullLoading.close();
        });
    },
    /**
     * 返回的方法
     * @author shuhua
     */
    fun_Back() {
      // 返回
      this.$router.back();
    },
    /**
     * 打开招标项目选择弹窗
     * @author shuhua
     */
    fun_OpenProjectDialog() {
      // 打开弹框时调用
      this.$refs.supConstructionChoose.searchFlag = "1";
      // 打开弹窗
      this.$refs.supConstructionChoose.dialogVisible = true;
      // 请求接口
      this.$refs.supConstructionChoose.fun_GetList();
    },
    /**
     * 设置项目信息
     */
    fun_SetProject(e) {
      // 前次报建主键
      this.form.firstConstructionId = e.id;
      // 前次报建编号
      this.form.firstConstructionNo = e.constructionNo;
      // 前次报建项目名称
      this.form.firstConstructionPrjName = e.prjName;
      // 旧数据为空时，页面显示为核验
      if(!e.isAudit){
        // 是否报送监管
        this.form.isAudit = "1";
      }else{
        // 赋值是否报送监管
        this.form.isAudit = e.isAudit;
      }
    },
    /**
     * 清空甲方变更项目信息
     */
    fun_CleanProject() {
      // 前次报建主键
      this.form.firstConstructionId = null;
      // 前次报建编号
      this.form.firstConstructionNo = null;
      // 前次报建项目名称
      this.form.firstConstructionPrjName = null;
    },
    /**
     * 全局加载
     * @author zhouzhou
     */
    fun_Loading() {
      this.fullLoading = Loading.service({
        lock: true,
        text: "正在进行效验，请耐心等待...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
    },
    /**
     * 导入
     */
    fun_Import() {
      // 打开遮罩
      this.fun_Loading();
      // 发起请求
      fun_PostAction("supConstruction/import", {
        ...this.form,
        controllerFlg: this.controllerFlg
      }).then(res => {
        // 解构res.data
        const { result, msg, data } = res.data;
        // 操作成功
        if (result) {
          // 加载框取消
          this.fullLoading.close();
          // 操作成功
          this.$message.success(msg);
          // 返回一览
          this.$router.back();
        } else {
          // 加载框取消
          this.fullLoading.close();
          // 返回不为空
          if (data != null) {
            // 定义rules为一个随机数
            this.errRules = Math.random();
            // 执行延迟方法
            this.$nextTick(() => {
              // 提示
              this.$message.error("您输入的数据存在错误！");
              // 赋值错误消息
              this.errRules = data;
            });
          } else {
            // 提示请求失败消息
            this.$message.error(msg);
          }
        }
      });
    },
    /**
     * 打开历史核验记录弹窗
     */
    fun_OpenAuditHistoryRecord() {
      // 打开弹窗
      this.$refs.auditHistoryRecord.dialogVisible = true;
      // 请求接口
      this.$refs.auditHistoryRecord.fun_GetList();
    },
    /**
     * 重新加载流程节点
     */
    fun_ReloadStepList(stepsActive) {
      // 执行处理页面显示方法
      this.fun_GetHandle();
      // 默认获取第一个流程表单
      this.formConfigList = this.stepsList[this.stepsActive].formList;
      // 初始化时处理流程判断表单是否填写内容
      this.fun_GetInitializeStepsIsData();
    },
    /**
     * 监听滚动
     */
    fun_HandleScroll(e) {
      // 判断
      if (e.target.offsetTop < this.$refs.sticky.offsetTop) {
        // 添加样式
        this.$refs.sticky.style.boxShadow = "0 0 8px 3px rgba(0, 0, 0, 0.06)";
      } else {
        // 添加样式
        this.$refs.sticky.style.boxShadow = "none";
      }
    },
    /**
     * 初始化时处理流程判断表单是否填写内容
     */
    fun_GetInitializeStepsIsData() {
      // 遍历流程数据
      this.stepsList.map((item, index) => {
        // 遍历表单内容
        item.formList.map(formList => {
          // 遍历表单字段
          formList.formConfigList.map(form => {
            // 判断是否填写内容
            if (this.form[form.value]) {
              // 改变状态
              item.isSave = true;
            }
          });
        });
      });
    },
    /**
     * 用于判断当前流程是否填写数据
     */
    fun_GetStepsIsData() {
      // 声明
      var formArr = []; // 所有表单
      var isFormKey = false; // 是否填写
      // 遍历获取所有表单数据
      this.formConfigList.map(item => {
        // 判断是否存在表单
        if (item.formConfigList && item.formConfigList.length > 0)
          formArr.push(...item.formConfigList);
      });
      // 判断当前表单
      for (var i = 0; i < formArr.length; i++) {
        // 判断字段是否填写值
        if (this.form[formArr[i].value]) {
          // 改变标识
          isFormKey = true;
          // 跳出循环
          break;
        }
      }
      return isFormKey;
    }
  }
};
